import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import ListarAlmacenPage from "./listar-almacen";
import AlmacenPage from "./almacen";

const RouterAlmacen = () => {
  const { path } = useRouteMatch();
  // console.log('RouterClientes');
  // console.log(path);
  return (
    <Switch>

      <Route exact path={`${path}`}>
        <ListarAlmacenPage />
      </Route>
      <Route exact path={`${path}/almacen`}>
        <AlmacenPage />
      </Route>

    </Switch>
  );
};

export default RouterAlmacen;
